import { Comment1 } from '../types';
import { store } from '../store/store';
import { fetchMilestoneMap, fetchObjectives } from '../store/map3DataSlice';
import { calculateIntervalRange } from '../store/selectors/intervalSelectors';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

export function getVideoFromComments(comments: Comment1[]) {
  return comments
    .filter((comment) => comment.videoUrl)
    .map((comment) => ({
      url: comment.videoUrl!,
      commentText: comment.text,
    }));
}

export async function getVideoFromObjectiveComments(
  milestoneMapUuid: string,
  objectiveUuid: string,
  interval?: string,
) {
  const objective = (await store.dispatch(fetchObjectives([objectiveUuid])).unwrap())[0];
  if (!objective?.comments) return [];

  if (interval) {
    // Find the milestone map for this objective
    const state = store.getState();
    const milestoneMap = state.map3Data.milestoneMaps.find((m) => m.uuid === milestoneMapUuid);
    if (!milestoneMap) return [];
    // Use the correct interval calculation
    const [previousIntervalEnd, intervalEnd] = calculateIntervalRange(interval, milestoneMap);
    const intervalComments = objective.comments.filter((comment) => {
      const commentDate = new Date(comment.forIntervalEnding);
      return commentDate > previousIntervalEnd && commentDate <= intervalEnd;
    });
    return getVideoFromComments(intervalComments);
  }

  // If no interval, return all videos
  return getVideoFromComments(objective.comments);
}

export async function getAllVideoFromCommentsAtInterval(mapId: string, interval: string) {
  const map = await store.dispatch(fetchMilestoneMap(mapId)).unwrap();
  if (!map?.objectiveUuids) return [];

  // Get all non-parent objectives
  const objectives = await store.dispatch(fetchObjectives(map.objectiveUuids)).unwrap();
  const nonParentObjectives = objectives.filter(
    (obj) => !map.parentObjectiveUuids?.includes(obj.uuid),
  );

  // Get all videos from each objective's comments for the interval
  const allVideos = await Promise.all(
    nonParentObjectives.map((obj) => getVideoFromObjectiveComments(mapId, obj.uuid, interval)),
  );

  // Flatten the array of arrays and return
  return allVideos.flat();
}
